import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class NotDeliveredReasonService {
  constructor(private http: HttpClient) {}

  public fetchNotDeliveredReasonList(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/notDeliveredReason/list`
    return this.http.post(url, params)
  }
  public fetchNotDeliveredReason(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/notDeliveredReason/${id}`
    return this.http.get(url, {})
  }

  public deleteNotDeliveredReason(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/notDeliveredReason/${id}`
    return this.http.delete(url)
  }

  public createNotDeliveredReason(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/notDeliveredReason`
    return this.http.post(url, params)
  }

  public updateNotDeliveredReason(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/notDeliveredReason/${id}`
    return this.http.put(url, params)
  }
}
